var n,t;!function(n){n.Annuity="annuity",n.ResidualPayment="residualPayment"}(n||(n={})),function(n){n.Top="top",n.Center="center"}(t||(t={}));export{n as CreditType,t as LogoPosition};
//# sourceMappingURL=FinanceCalc.types.js.map
